"use strict";

angular.module('PatientApp').factory('FinancingService', function (VuexStore) {
  return {
    getOptions: function getOptions(application) {
      return VuexStore.dispatch('getFinancingOptions', application);
    },
    getRedirectUrl: function getRedirectUrl(secureCode, vendor) {
      return VuexStore.dispatch('getFinancingRedirectUrl', {
        secureCode: secureCode,
        vendor: vendor
      });
    },
    manageAccount: function manageAccount(secureCode) {
      return VuexStore.dispatch('manageFinancingAccount', secureCode);
    },
    chooseOption: function chooseOption(secureCode, vendor, option) {
      return VuexStore.dispatch('chooseFinancingOption', {
        secureCode: secureCode,
        vendor: vendor,
        option: option
      });
    },
    chargeFinancingPaymentFormFirstTime: function chargeFinancingPaymentFormFirstTime(body) {
      return VuexStore.dispatch('chargeFinancingPaymentFormFirstTime', body);
    },
    chargeExistingFinancingAccount: function chargeExistingFinancingAccount(body) {
      return VuexStore.dispatch('chargeExistingFinancingAccount', body);
    },
    getStatus: function getStatus(vendor, secureCode) {
      return VuexStore.dispatch('getFinancingStatus', {
        vendor: vendor,
        secureCode: secureCode
      });
    },
    getDownloadUrl: function getDownloadUrl(vendor, fileId, fileName) {
      return VuexStore.getters.getFinancingDownloadUrl({
        vendor: vendor,
        fileId: fileId,
        fileName: fileName
      });
    }
  };
});